import { makeAutoObservable } from "mobx";

import { UserBudgetReadModel, UserBudgetReadModelFromJSON } from "../../@api";

export class BudgetStore {
  private _budgetInfo: UserBudgetReadModel = UserBudgetReadModelFromJSON({
    hasBudget: false,
    currentUsage: 0,
    budgetLimit: 0,
  } as UserBudgetReadModel);

  private _budgetDisabled: boolean = false;

  private errorStatusCode?: number;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get hasBudget(): boolean {
    return this._budgetInfo.hasBudget && !this._budgetDisabled;
  }

  setBudgetInfo(value: UserBudgetReadModel): void {
    this._budgetInfo = value;
  }

  setBudgetDisabled(value: boolean): void {
    this._budgetDisabled = value;
  }

  get budgetInfoValue(): UserBudgetReadModel {
    return this._budgetInfo;
  }

  get errorCode(): number | undefined {
    return this.errorStatusCode;
  }

  set errorCode(value: number | undefined) {
    if (this.errorStatusCode !== value) {
      this.errorStatusCode = value;
    }
  }
}
